import * as React from "react";
import { Input, Divider, Checkbox, Form, Row, Col } from "antd";
import { FormInstance } from "antd/lib/form";
import { IGenericCodebookItem } from "../model/GenericCodebookItem";
import { GenericCodebookItemFormFields } from "../../core/common/Constants";

const GenericCodebookItemForm = ({
  translate,
  form,
  rowData,
  addNewCodebook,
  addNewCodebookItem
}: {
  translate: any;
  form: FormInstance;
  rowData?: IGenericCodebookItem;
  addNewCodebook?: boolean;
  addNewCodebookItem?: boolean;
}) => {
  return (
    <Form layout={"vertical"} form={form}>
      {addNewCodebook && (
        <div>
          <Form.Item
            label={translate("generic_codebook.type")}
            style={{ backgroundColor: "#f0f0f0", padding: 10, borderRadius: 5 }}
            name={GenericCodebookItemFormFields.TYPE}
            initialValue={rowData?.type}
            rules={[
              {
                required: true,
                message: translate("generic_codebook.required_messages", {
                  field: translate("generic_codebook.type")
                })
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Divider type={"horizontal"} className={"divider-horizontal"} />
          <h4>{translate("generic_codebook.insert_value")}</h4>
        </div>
      )}
      <Form.Item
        style={{ display: "none" }}
        name={GenericCodebookItemFormFields.ID}
        initialValue={rowData?.id}
      >
        <Input />
      </Form.Item>
      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col
          sm={!addNewCodebookItem ? 20 : 24}
          xs={!addNewCodebookItem ? 20 : 24}
        >
          <Form.Item
            label={translate("generic_codebook.code")}
            className={"mb-0"}
            name={GenericCodebookItemFormFields.CODE}
            initialValue={rowData?.code}
            rules={[
              {
                required: true,
                message: translate("generic_codebook.required_messages", {
                  field: translate("generic_codebook.code")
                })
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        {!addNewCodebookItem && (
          <Col
            sm={4}
            xs={4}
            style={{
              display: "flex",
              marginTop: 20,
              alignItems: "center"
            }}
          >
            <Form.Item
              label={translate("generic_codebook.valid")}
              className={"png-form-item-horizontal-checkbox mb-0"}
              name={GenericCodebookItemFormFields.VALID}
              valuePropName={"checked"}
              initialValue={rowData ? rowData.valid : true}
              rules={[
                {
                  required: true,
                  message: translate("generic_codebook.required_messages", {
                    field: translate("generic_codebook.valid")
                  })
                }
              ]}
            >
              <Checkbox />
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
        <Col sm={24} xs={24}>
          <Form.Item
            label={translate("generic_codebook.value")}
            className={"mb-0"}
            name={GenericCodebookItemFormFields.VALUE}
            initialValue={rowData?.value}
            rules={[
              {
                required: true,
                message: translate("generic_codebook.required_messages", {
                  field: translate("generic_codebook.value")
                })
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default GenericCodebookItemForm;
